module.exports = __webpack_public_path__ + "static/whats-458f44198145e2267eb190ee1f1e3980.png";